import React from "react";
import { IconButton as MuiIconButton } from "@material-ui/core";
import { Icon } from "../Icon/Icon";
import clsx from "clsx";
import { IconButtonPropsModel } from "./tools/IconButton.model";

import useStyles from "./IconButton.style";

export const IconButton = ({
  size = 'default',
  variant = 'primary',
  icon,
  onClick,
  className,
  disabled,
  testId,
  autoTestId,
  ariaLabel,
  label,
}: IconButtonPropsModel) => {
  const c = useStyles({ size, variant, label });
  return (
    <MuiIconButton
      className={clsx({
        [c.root]: true,
        [className || '']: !!className,
        [c.isDisabled]: disabled,
      })}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      data-testid={testId}
      data-autotestid={autoTestId}
      aria-label={ariaLabel}
      data-type="ui/IconButton"
    >
      <span className={c.iconWrapper}>
        <Icon className={c.icon}>{icon}</Icon>
      </span>
      {label && <span className={c.label}>{label}</span>}
    </MuiIconButton>
  );
};
